import { Link } from "react-router-dom"
import { Flex, Grid, Text, Title, createStyles, Paper, Button, Badge, Group } from "@mantine/core"
import { Image } from "shared/ui/Image"
import { fDate } from "shared/lib/dates"
import { categoryNames } from "shared/lib/constants"
import { PATHS } from "shared/lib/paths"
import { type Article } from "shared/types/article"
import { API_URL } from "shared/config"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  paper: {
    padding: theme.spacing.xl,
    boxShadow: theme.shadows.light,

    "&:not(:first-of-type)": {
      marginTop: "4rem",

      [theme.fn.smallerThan("md")]: {
        marginTop: "2rem",
      },
    },

    [theme.fn.smallerThan("lg")]: {
      padding: theme.spacing.md,
    },

    [theme.fn.smallerThan("md")]: {
      padding: theme.spacing.xs,
    },

    [theme.fn.smallerThan("xs")]: {
      padding: 0,
    },
  },

  gridElem: {
    padding: theme.spacing.xl,

    [theme.fn.smallerThan("lg")]: {
      padding: theme.spacing.md,
    },

    [theme.fn.smallerThan("md")]: {
      padding: theme.spacing.xs,
    },

    [theme.fn.smallerThan("xs")]: {
      "&:first-of-type": {
        padding: theme.spacing.xl,
      },

      "&:last-of-type": {
        padding: 0,
      },
    },
  },

  title: {
    [theme.fn.smallerThan("md")]: {
      fontSize: theme.headings.sizes.h2.fontSize,
    },

    [theme.fn.smallerThan("xs")]: {
      fontSize: theme.headings.sizes.h3.fontSize,
    },
  },

  image: {
    borderRadius: theme.radius.xl,

    [theme.fn.smallerThan("xs")]: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },

  description: {
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
}))

// ----------------------------------------------------------------------

export function ArticleListElement(
  {
    title,
    description,
    cover,
    createdAt,
    category,
    _id,
  }: Article): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Paper mx={2} radius="xl" className={classes.paper}>
      <Grid grow gutter={0}>
        <Grid.Col span={12} xs={8} className={classes.gridElem} order={2} orderXs={1}>
          <Flex direction="column">
            <Text transform="capitalize" c="dimmed" mb="md">
              {fDate(createdAt)}
            </Text>
            <Title mb="md" className={classes.title}>
              {title}
            </Title>
            <Group>
              <Badge gradient={{ from: "orange", to: "red" }} variant="gradient" size="lg" mb="md">
                {categoryNames[category]}
              </Badge>
            </Group>

            <Text className={classes.description}>{description}</Text>
            <Button
              radius="xl"
              size="md"
              color="dark"
              mt="xl"
              w="max-content"
              component={Link}
              to={PATHS.BLOG.DETAILS(_id)}
            >
              Читать
            </Button>
          </Flex>
        </Grid.Col>
        <Grid.Col span={12} xs={4} className={classes.gridElem} order={1} orderXs={2}>
          <Image src={`${API_URL}/media/${cover}`} alt={title} className={classes.image}/>
        </Grid.Col>
      </Grid>
    </Paper>
  )
}
